export default {
  booking: {
    title: 'Booking Information',
    bookingTitle: 'Booking Title',
    seatType: 'Seat Type',
    attendanceDate: 'Attendance Date',
    participationTime: 'Boarding time',
    trainModel: 'Train type',
    seatInfo: 'Seat Info',
    reservationCount: 'Number of passenger',
    viewDetail: 'View details',
    bookingRange: {
      oneMonth: 'Bookings within 1 month',
      threeMonths: 'Bookings within 3 months',
      sixMonths: 'Bookings within 6 months'
    },
    adultTicket: 'Adult Ticket',
    childTicket: 'Child Ticket',
    status: {
      paymentPending: 'Payment Pending',
      paid: 'Booking submitted. Confirming ticket issuance',
      confirmed: 'Booking successful, ticket issued',
      cancelPending: 'Cancel Pending',
      cancelled: 'Cancelled',
      refunded: 'Refunded',
      paymentExpired: 'Payment Expired',
      completed: 'Completed',
      confirmFailed: 'Confirm Failed'
    }
  },
  bookingDetail: {
    title: 'Booking Information',
    travelInfo: 'Travel Information',
    digitalTicket: 'Digital Ticket',
    meetingPoint: 'Boarding Location Information',
    beforeTrip: 'Note before boarding',
    bookingAction: 'Booking Action',
    cancelBooking: 'Cancel Booking',
    cancelConfirmPolicy: 'Please confirm the cancellation policy:',
    cancelTip:
      'If you need to cancel your order after it has been issued, please do so within 1 hour before the departure time. Otherwise, you will not be able to cancel and refund, so please be aware.',
    sendToEmail: 'Send to Email',
    attendanceDate: 'Boarding date',
    customerName: 'Customer Name',
    email: 'Email',
    actualPayment: 'Total payment',
    orderId: 'Order ID',
    orderCompletionTime: 'Order Completion Time',
    digitalTicketValidPeriod: 'QR code is valid only on the day of travel',
    digitalTicketWaiting:
      '*After order confirmation, the digital ticket will be displayed here',
    sending: 'Sending...',
    sendToEmailSuccess: 'Email sent successfully, please check your email'
  }
};
